import { CloseIcon } from '../lib/CloseIcon'
import { NewChristmasGift } from './types'

type Props = {
  onClose: () => void
  onSave: (gift: NewChristmasGift) => void
  newGift: NewChristmasGift
  setNewGift: (gift: NewChristmasGift) => void
}

export function NewModal({ onClose, newGift, setNewGift, onSave }: Props) {
  return (
    <>
      <div className="cg-modal-background"></div>
      <div className="cg-modal-new-dialog">
        <div className="cg-modal-title">
          <div className="flex flex-justify-between flex-align-center">
            <div>Details</div>
            <div className="cg-close" onClick={() => onClose()}>
              <CloseIcon width={22} height={22} />
            </div>
          </div>
        </div>
        <div className="cg-modal-content flex flex-col" style={{ gap: 5 }}>
          <div className="cg-modal-subtitle">Gift for</div>
          <div className="flex">
            <div style={{ width: 150 }}>First name</div>
            <div>
              <input
                value={newGift.FirstName}
                onChange={(e) =>
                  setNewGift({ ...newGift, FirstName: e.target.value })
                }
              />
            </div>
          </div>
          <div className="flex">
            <div style={{ width: 150 }}>Last name</div>
            <div>
              <input
                value={newGift.LastName}
                onChange={(e) =>
                  setNewGift({ ...newGift, LastName: e.target.value })
                }
              />
            </div>
          </div>
          <div className="flex">
            <div style={{ width: 150 }}>E-mail</div>
            <div>
              <input
                value={newGift.Email}
                onChange={(e) =>
                  setNewGift({ ...newGift, Email: e.target.value })
                }
              />
            </div>
          </div>
          <div className="flex" style={{ gap: 12 }}>
            <div style={{ width: 150 }}></div>
            <button className="cg-modal-button" onClick={() => onSave(newGift)}>
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  )
}
